import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['descriptionField', 'modal'];

  // Add the selected preset text to the description field
  addPreset(event) {
    const preset = event.currentTarget.dataset.preset;

    if (this.hasDescriptionFieldTarget) {
      // Get current value and append the preset with spacing
      const currentValue = this.descriptionFieldTarget.value;
      const newValue = currentValue
        ? currentValue.endsWith(' ')
          ? currentValue + preset
          : currentValue + ' ' + preset
        : preset;

      // Update the field
      this.descriptionFieldTarget.value = newValue;
      this.descriptionFieldTarget.dispatchEvent(new Event('input'));

      // Close the modal
      this.closeModal();
    }
  }

  // Open the modal
  openModal() {
    if (this.hasModalTarget) {
      this.modalTarget.showModal();
    }
  }

  // Close the modal
  closeModal() {
    if (this.hasModalTarget) {
      this.modalTarget.close();
    }
  }
}
